function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/*********************************************************************************

 WEB3 CRYPTO MODULE v.2

 This is a general parent class for modules that wish to define a cryptocurrency 
 that can interact with the Saito ecosystem. It introduces generic  functions that 
 should be implemented by these modules to handle web3 cryptos interaction with 
 their external blockchains or  networks. 

 To understand how your module can integrate cryptocurrencies, the API is handled
 in lib/saito/wallet.ts

  Minimum extension functionality: 
  -- checkBalance
  -- returnPrivateKey
  -- sendPayment
  -- receivePayment
  -- checkHistory
  -- checkWithdrawalFeeForAddress

**********************************************************************************/
var ModTemplate = require('./modtemplate');
var CryptoModule = /*#__PURE__*/function (_ModTemplate) {
  /**
   * Initialize CryptoModule and check that subclass overrides abstract functions
   * @param {Object} app - Saito Application Context
   * @param {String} ticker - Ticker symbol of underlying Cryptocurrency
   * @example
   * constructor(app, ticker, ...) {
   *   super(app, ticker);
   *   ...
   * }
   */
  function CryptoModule(app, ticker) {
    var _this;
    _classCallCheck(this, CryptoModule);
    _this = _callSuper(this, CryptoModule, [app]);
    _this.app = app;
    _this.ticker = ticker;
    _this.name = ticker;
    _this.categories = 'Cryptocurrency';
    _this.description = '';

    //
    // some modules issue warnings to users on selection
    // see ui/saito-crypto/overlays/activate.js
    //
    _this.warning = '';
    _this.introduction = '';
    _this.confirmations = 0;

    //
    // quick sanity check -- cache the balance
    //
    _this.balance = '0.0';
    _this.address = '';

    //
    // cached in memory / localForage -- list of standardized objects detailing transaction history
    //
    _this.history = [];
    _this.history_update_ts = 0;

    //
    // info stored in options file, you can safely add items as necessary
    //
    _this.options = {};
    _this.options.isActivated = false;
    return _this;
  }

  /**
   * Saito Module initialize function
   * @param {*} app
   */
  _inherits(CryptoModule, _ModTemplate);
  return _createClass(CryptoModule, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(CryptoModule, "initialize", this, 3)([app]);
            case 1:
              //
              // We save the state of our crypto wallet local storage (options file)
              //
              console.log('Initializing ' + this.ticker);
              _context.n = 2;
              return this.load();
            case 2:
              if (!(this.ticker === this.app.wallet.returnPreferredCryptoTicker())) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return this.activate();
            case 3:
              // if UI is enabled, will re-render the qr code, ticker, and balance in the hamburger menu
              this.app.connection.emit('saito-header-update-crypto');
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() ///////////////////////////////////////////////
    // Accept payments even from blacklisted people
    ///////////////////////////////////////////////
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this2 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'saito-moderation-app') {
        return {
          filter_func: function filter_func() {
            var mod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            if (tx == null || mod == null || !(tx !== null && tx !== void 0 && tx.from)) {
              return 0;
            }

            //This function is called with every module for some reasons
            if (mod.name !== _this2.name) {
              return 0;
            }
            return 1;
          }
        };
      }
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(Number(conf) == 0)) {
                _context2.n = 5;
                break;
              }
              if (!(!tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey))) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, 0);
            case 1:
              _context2.n = 2;
              return tx.decryptMessage(this.app);
            case 2:
              txmsg = tx.returnMessage();
              if (!(txmsg.module !== this.name)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, 0);
            case 3:
              if (!this.hasSeenTransaction(tx, Number(blk.id))) {
                _context2.n = 4;
                break;
              }
              console.error('We are double processing a payment transaction!!!!');
              return _context2.a(2, 1);
            case 4:
              if (!(txmsg.request === 'crypto payment')) {
                _context2.n = 5;
                break;
              }
              console.log('>>>>>>>>>> crypto payment', 'Conf:', conf, 'Block: ', blk.id, tx.from[0].publicKey, '-->', tx.to[0].publicKey, '\n>>', tx.msg);
              if (this.app.BROWSER) {
                this.receivePaymentTransaction(tx);
              }
              return _context2.a(2, 1);
            case 5:
              return _context2.a(2, 0);
          }
        }, _callee2, this);
      }));
      function onConfirmation(_x2, _x3, _x4) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "sendPaymentTransaction",
    value: function () {
      var _sendPaymentTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(publicKey, from_address, to_address, amount, hash) {
        var memo,
          newtx,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              memo = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : '';
              _context3.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(publicKey);
            case 1:
              newtx = _context3.v;
              newtx.msg = {
                module: this.name,
                request: 'crypto payment',
                amount: amount,
                from: from_address,
                to: to_address,
                hash: hash
              };
              if (memo) {
                newtx.msg.memo = memo;
              }
              _context3.n = 2;
              return newtx.sign();
            case 2:
              _context3.n = 3;
              return this.app.network.propagateTransaction(newtx);
            case 3:
              console.info("Crypto: sendPaymentTransaction sent to ".concat(publicKey, "!"), newtx.msg);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function sendPaymentTransaction(_x5, _x6, _x7, _x8, _x9) {
        return _sendPaymentTransaction.apply(this, arguments);
      }
      return sendPaymentTransaction;
    }() //
    // Only implemented for $SAITO
    //
  }, {
    key: "savePaymentTransaction",
    value: function savePaymentTransaction(tx) {}

    //////////////////////////
    // BROWSER ONLY!!!
    //////////////////////////
  }, {
    key: "receivePaymentTransaction",
    value: function receivePaymentTransaction(tx) {
      var txmsg = tx.returnMessage();
      var role = 'Unknown';
      if (tx.isTo(this.publicKey)) {
        role = 'Recipient';
      }
      if (tx.isFrom(this.publicKey)) {
        role = 'Sender';
      }
      console.info("Crypto: receivePaymentTransaction as ".concat(role), txmsg);
      if (!tx.isFrom(this.publicKey)) {
        var _this$options;
        if (!this.ticker.toLowerCase().includes('saito')) {
          this.app.keychain.addCryptoAddress(tx.from[0].publicKey, this.ticker, txmsg.from);
        }
        var expected_payment = false;
        if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.transfers_inbound) {
          for (var i = 0; i < this.options.transfers_inbound.length; i++) {
            if (this.options.transfers_inbound[i] == txmsg.hash) {
              expected_payment = true;
              this.options.transfers_inbound.splice(i, 1);
              this.save();
              break;
            }
          }
        }

        //
        // updates the in-game receive payment overlay or just display a siteMessage
        //
        if (expected_payment) {
          this.app.connection.emit('saito-crypto-receive-confirm', txmsg);
        } else {
          siteMessage("".concat(txmsg.amount, " ").concat(this.ticker, " inbound from ").concat(this.app.keychain.returnUsername(tx.from[0].publicKey)), 3000);
        }
      } else {
        //
        // I sent the payment!
        // If web3 crypto, make sure I save my friend's address
        //
        if (!this.ticker.toLowerCase().includes('saito')) {
          this.app.keychain.addCryptoAddress(tx.to[0].publicKey, this.ticker, txmsg.to);
        }
      }
      this.savePaymentTransaction(tx);
      setTimeout(this.checkBalanceUpdate.bind(this), 2000);
    }
  }, {
    key: "saveInboundPayment",
    value: function saveInboundPayment(hash) {
      var _this$options2;
      if (!((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.transfers_inbound)) {
        this.options.transfers_inbound = [];
      }
      if (!this.options.transfers_inbound.includes(hash)) {
        this.options.transfers_inbound.push(hash);
        this.save();
        return {
          hash: hash
        };
      } else {
        console.warn('Crypto: Already saved expected payment');
        return {
          err: 'Already saved expected payment'
        };
      }
    }
  }, {
    key: "returnLogos",
    value: function returnLogos() {
      return this.app.modules.getRespondTos('crypto-logo', {
        ticker: this.ticker
      }).shift() || {
        img: this.icon_url || "/".concat(this.ticker.toLowerCase(), "/img/logo.png")
      };
    }

    /**
     * @return true/false as to whether the crypto module is installed/activated (e.g. has a valid address)
     */
  }, {
    key: "isActivated",
    value: function isActivated() {
      var _this$app$options;
      //
      // modules might want to know which cryptos are activated before the
      // crypto modules themselves have initialize(app), in which case we
      // have a fallback.
      //
      if ((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.crypto) {
        if (this.app.options.crypto[this.ticker]) {
          if (this.app.options.crypto[this.ticker].isActivated) {
            return true;
          }
        }
      }
      return this.options.isActivated;
    }

    /**
     * isActivated is an optional flag that allows users to enable a crypto module.
     * This is needed to accomodate UX in the case that a particular module might
     * require significant resources.
     */
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var info;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.checkBalance();
            case 1:
              _context4.n = 2;
              return this.checkHistory();
            case 2:
              if (this.options.isActivated) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return this.returnNetworkInfo();
            case 3:
              info = _context4.v;
              console.log("Activated ".concat(this.ticker, ": "), info);
              this.options.isActivated = true;
            case 4:
              this.app.connection.emit('saito-crypto-activated', this.ticker);
              this.save();
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     *  This function exists only to create a potential stop point in receivePayment
     *  Instead of refactoring it into oblivion, the code is interesting and may be a good
     *  reference for connecting an event listener to receivePayment in leiu of repeated polling
     */
  }, {
    key: "onIsActivated",
    value: function onIsActivated() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        if (_this3.isActivated()) {
          resolve();
        } else {
          _this3.app.connection.on('saito-crypto-activated', function (ticker) {
            if (ticker === _this3.ticker) {
              resolve();
            }
          });
          _this3.activate();
        }
      });
    }

    /**
     * Synchronous getter of crypto balance
     * @return {String} cached balance
     */
  }, {
    key: "returnBalance",
    value: function returnBalance() {
      return this.balance;
    }
  }, {
    key: "checkBalanceUpdate",
    value: function () {
      var _checkBalanceUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var original_balance, new_balance, diff, msg, _msg;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              console.log('$$$$ checkBalanceUpdate');
              original_balance = Number(this.balance);
              _context5.n = 1;
              return this.checkBalance();
            case 1:
              new_balance = Number(this.returnBalance());
              diff = new_balance - original_balance;
              if (!(diff == 0)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (diff > 0) {
                msg = "New ".concat(this.app.browser.formatDecimals(diff), " ").concat(this.ticker, " deposit");
                siteMessage(msg, 3000);
              } else {
                _msg = "New ".concat(this.app.browser.formatDecimals(-diff), " ").concat(this.ticker, " payment");
                siteMessage(_msg, 3000);
              }
              this.app.connection.emit('saito-header-update-crypto');
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function checkBalanceUpdate() {
        return _checkBalanceUpdate.apply(this, arguments);
      }
      return checkBalanceUpdate;
    }()
    /**
     * Abstract method which should get pubkey/address
     * @abstract
     * @return {String} Pubkey/address
     */
  }, {
    key: "returnAddress",
    value: function returnAddress() {
      try {
        return this.address;
      } catch (error) {
        console.error('Crytpo: [returnAddress] ERROR:', error);
      }
    }
  }, {
    key: "formatAddress",
    value: function formatAddress() {
      return this.returnAddress();
    }
  }, {
    key: "returnHistory",
    value: function returnHistory() {
      return this.history;
    }

    /**
     * load state of this module from local storage
     */
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$app;
        var _this$options3, _this$options4, history, _this$history;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              //
              // info stored in options file
              //

              if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.options) !== null && _this$app !== void 0 && _this$app.crypto) {
                if (this.app.options.crypto[this.ticker]) {
                  this.options = this.app.options.crypto[this.ticker];

                  // For convenience we put balance and address at the top level of the module
                  if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.balance && Number(this.balance) == 0) {
                    this.balance = this.options.balance;
                  }
                  if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.address && !(this !== null && this !== void 0 && this.address)) {
                    this.address = this.options.address;
                  }
                  if (this.options.confirmations) {
                    this.confirmations = this.options.confirmations;
                  }
                }
              }
              if (!this.address) {
                _context6.n = 4;
                break;
              }
              _context6.n = 1;
              return this.app.storage.getLocalForageItem("".concat(this.ticker, "_").concat(this.address, "_history"));
            case 1:
              history = _context6.v;
              if (!history) {
                _context6.n = 3;
                break;
              }
              this.history = JSON.parse(history);
              if (((_this$history = this.history) === null || _this$history === void 0 ? void 0 : _this$history.length) > 0) {
                this.history_update_ts = this.history[this.history.length - 1].timestamp;
                console.log("Crypto History up to ".concat(new Date(this.history_update_ts), "!"), this.history);
              }
              _context6.n = 2;
              return this.validateHistory();
            case 2:
              _context6.n = 4;
              break;
            case 3:
              this.history = [];
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }() // To correct any cached history records with duplicated values...
  }, {
    key: "validateHistory",
    value: function () {
      var _validateHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var i, j;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.history.length)) {
                _context7.n = 6;
                break;
              }
              j = i + 1;
            case 2:
              if (!(j < this.history.length)) {
                _context7.n = 5;
                break;
              }
              if (!(this.history[i].timestamp === this.history[j].timestamp && this.history[i].amount == this.history[j].amount)) {
                _context7.n = 4;
                break;
              }
              console.warn('We saved malformatted crypto transaction history... clearing local cache');
              _context7.n = 3;
              return this.app.storage.removeLocalForageItem("".concat(this.ticker, "_").concat(this.address, "_history"));
            case 3:
              this.history = [];
              this.history_update_ts = 0;
            case 4:
              j++;
              _context7.n = 2;
              break;
            case 5:
              i++;
              _context7.n = 1;
              break;
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function validateHistory() {
        return _validateHistory.apply(this, arguments);
      }
      return validateHistory;
    }()
    /**
     * save state of this module to local storage
     */
  }, {
    key: "save",
    value: function save() {
      var _this$app2, _this$options5, _this$options6, _this$history2;
      if (!((_this$app2 = this.app) !== null && _this$app2 !== void 0 && (_this$app2 = _this$app2.options) !== null && _this$app2 !== void 0 && _this$app2.crypto)) {
        this.app.options.crypto = {};
      }
      if (!this.app.options.crypto[this.ticker]) {
        this.app.options.crypto[this.ticker] = {};
      }
      this.options.confirmations = this.confirmations;

      //
      // Update the fields that we duplicte directly in the module
      //
      this.options.balance = this.balance;
      this.options.address = this.address;
      if (!((_this$options5 = this.options) !== null && _this$options5 !== void 0 && (_this$options5 = _this$options5.transfers_inbound) !== null && _this$options5 !== void 0 && _this$options5.length)) {
        delete this.options.transfers_inbound;
      }
      if (!((_this$options6 = this.options) !== null && _this$options6 !== void 0 && (_this$options6 = _this$options6.transfers_outbound) !== null && _this$options6 !== void 0 && _this$options6.length)) {
        delete this.options.transfers_outbound;
      }

      // Clean up legacy storage
      delete this.options.destination;
      this.app.options.crypto[this.ticker] = this.options;
      this.app.storage.saveOptions();
      if ((_this$history2 = this.history) !== null && _this$history2 !== void 0 && _this$history2.length) {
        this.app.storage.setLocalForageItem("".concat(this.ticker, "_").concat(this.address, "_history"), JSON.stringify(this.history));
      }
    }
  }, {
    key: "returnAddressFromPublicKey",
    value: function () {
      var _returnAddressFromPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(publicKey) {
        var key;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!this.validateAddress(publicKey)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, publicKey);
            case 1:
              if (this.app.wallet.isValidPublicKey(publicKey)) {
                _context8.n = 2;
                break;
              }
              throw new Error("Error 237509: ".concat(publicKey, " is not a Saito public key"));
            case 2:
              key = this.app.keychain.returnKey(publicKey, true);
              if (!(key !== null && key !== void 0 && key.crypto_addresses)) {
                _context8.n = 3;
                break;
              }
              return _context8.a(2, key.crypto_addresses[this.ticker]);
            case 3:
              return _context8.a(2, null);
          }
        }, _callee8, this);
      }));
      function returnAddressFromPublicKey(_x0) {
        return _returnAddressFromPublicKey.apply(this, arguments);
      }
      return returnAddressFromPublicKey;
    }()
  }]);
}(ModTemplate);
/**
 * Abstract method which should get balance from underlying crypto endpoint
 * @abstract
 * @return {Number}
 */
CryptoModule.prototype.checkBalance = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
  return _regenerator().w(function (_context9) {
    while (1) switch (_context9.n) {
      case 0:
        throw new Error('checkBalance must be implemented by subclass!');
      case 1:
        return _context9.a(2);
    }
  }, _callee9);
}));

/**
 * Abstract method which should get private key
 * @abstract
 * @return {String} Private Key
 */
CryptoModule.prototype.returnPrivateKey = function () {
  throw new Error('returnPrivateKey must be implemented by subclass!');
};

/**
 * Abstract method which should transfer tokens via the crypto endpoint
 * @abstract
 * @param {Number} howMuch - How much of the token to transfer
 * @param {String} to - Pubkey/address to send to
 * @param {String} uniqueHash - to make sure the code doesn't trigger this twice on browser refresh
 * @return {Number}
 */
CryptoModule.prototype.sendPayment = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
  var amount,
    recipient,
    unique_hash,
    _args0 = arguments;
  return _regenerator().w(function (_context0) {
    while (1) switch (_context0.n) {
      case 0:
        amount = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : '';
        recipient = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : '';
        unique_hash = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : '';
        throw new Error('sendPayment must be implemented by subclass!');
      case 1:
        return _context0.a(2);
    }
  }, _callee0);
}));

/**
 * Searches for a payment which matches the criteria specified in the parameters.
 * @abstract
 * @param {Number} howMuch - How much of the token was transferred
 * @param {String} from - Pubkey/address the transasction was sent from
 * @param {String} to - Pubkey/address the transasction was sent to
 * @param {timestamp} to - timestamp after which the transaction was sent
 * @return {Boolean}
 */
CryptoModule.prototype.receivePayment = function (amount, sender, recipient, timestamp) {
  var unique_hash = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  throw new Error('receivePayment must be implemented by subclass!');
};

/**
 * Abstract method
 * @abstract
 * @param {function} callback - function to call when the data is being fetched/sorted
 * @return {object} payment history data
 */
CryptoModule.prototype.checkHistory = function () {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  throw new Error('checkHistory must be implemented by subclass!');
};
CryptoModule.prototype.checkWithdrawalFeeForAddress = function () {
  var recipient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (mycallback != null) {
    mycallback(0);
  }
};

/**
 * fetch pending deposits
 * @abstract
 * @param {function} callback function
 * @return {array} list of pending deposits
 */

CryptoModule.prototype.fetchPendingDeposits = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(callback) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          if (callback != null) {
            callback([]);
          }
        case 1:
          return _context1.a(2);
      }
    }, _callee1);
  }));
  return function (_x1) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Validate given address
 * @abstract
 * @param {string} address to validate
 * @param {string} ticker to for selected crypto
 * @return {boolean} true/false
 */
CryptoModule.prototype.validateAddress = function (address) {
  return true;
};

/**
 * return utxo
 * @abstract
 * @param {string} address to validate
 * @param {string} ticker to for selected crypto
 * @return {boolean} true/false
 */
CryptoModule.prototype.returnUtxo = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
  var state,
    limit,
    order,
    _args10 = arguments;
  return _regenerator().w(function (_context10) {
    while (1) switch (_context10.n) {
      case 0:
        state = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : 'unspent';
        limit = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : 1000;
        order = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : 'DESC';
        return _context10.a(2, true);
    }
  }, _callee10);
}));
CryptoModule.prototype.returnNetworkInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(ticker) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, {
            confirmations: 0
          });
      }
    }, _callee11);
  }));
  return function (_x10) {
    return _ref5.apply(this, arguments);
  };
}();
module.exports = CryptoModule;